var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.3"},React.createElement("path",{"d":"M23.9988 0.00665814L19.8491 0C15.1872 0 12.1744 3.09104 12.1744 7.87524V11.5063H8.0021C7.64157 11.5063 7.34961 11.7985 7.34961 12.1591V17.42C7.34961 17.7806 7.6419 18.0725 8.0021 18.0725H12.1744V31.3475C12.1744 31.708 12.4663 32 12.8269 32H18.2705C18.631 32 18.923 31.7077 18.923 31.3475V18.0725H23.8014C24.1619 18.0725 24.4539 17.7806 24.4539 17.42L24.4558 12.1591C24.4558 11.986 24.3869 11.8202 24.2648 11.6977C24.1426 11.5752 23.9761 11.5063 23.803 11.5063H18.923V8.4282C18.923 6.94876 19.2755 6.19773 21.2027 6.19773L23.9981 6.19673C24.3583 6.19673 24.6503 5.90443 24.6503 5.54423V0.659155C24.6503 0.299283 24.3586 0.00732395 23.9988 0.00665814Z","fill":"black"})));
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
